import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useNavigate, useLocation, useParams } from 'react-router-dom';

import MainBody from '../../components/layout/MainBody';
import Section from '../../components/layout/Section';
import FormContainer from '../../components/UI/FormContainer';
import PageTitle from '../../components/UI/PageTitle';
import { Field } from '../../components/UI/Form';
import { Medium } from '../../components/UI/Text';
import { FONT } from '../../styles/color';
import Button from '../../components/UI/Button';
import { POST_TYPE } from '../../utils/constants';
import { boardApi } from '../../api/board';

const PostContainer = styled.div`
	width: 900px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 100px;
	align-items: center;
`;

const TextAreaWrapper = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 25px;
	justify-content: flex-start;
	align-items: flex-start;
`;

const TextArea = styled.textarea`
	width: 100%;
	height: 450px;
	border: 1px solid ${ FONT.deep01 };
	border-radius: 8px;
	box-sizing: border-box;
	padding: 20px 10px;
	font: normal 400 18px Pretendard Variable;
	color: ${ FONT.default };
	resize: none;

	&::placeholder {
		color: ${ FONT.deep01 };
	}

	&:focus {
		outline: none;
	}

	&::-webkit-outer-spin-button,
  	&::-webkit-inner-spin-button {
    	-webkit-appearance: none;
    	margin: 0;
  	}

  	&[type=number] {
    	-moz-appearance: textfield;
  	}
`;

export default function PostForm() {
	const navigate = useNavigate();
	const location = useLocation();
	const params = useParams();

	const [formData, setFormData] = React.useState({
		postType: Object.keys(POST_TYPE)[0],
		title: '',
		content: ''
	});

	useEffect(() => {
		if(location.pathname.includes('edit') && location.state && location.state.post) {
			const post = location.state.post;
			if(post) {
				setFormData({
					postType: post.postType,
					title: post.title,
					content: post.content
				});
			}
		}
	}, [location]);

	const handleChange = (e) => {
		setFormData({
			...formData,
			[e.target.name]: e.target.value
		});
	};

	const handleSubmit = (e) => {
		e.preventDefault();

		if(!formData.title || !formData.content) {
			alert('모든 항목을 입력해주세요.');
			return;
		}

		if(location.pathname.includes('edit')) {
			// 게시글 수정 API 호출
			boardApi.editPost(params.postId, formData)
				.then((response) => {
					navigate(
						`/board/${params.postId}`
					);
				})
				.catch((error) => {
					alert('게시글 수정에 실패했습니다. 다시 시도해주세요.');
				});
			return;
		}
		
		// 게시글 작성 API 호출
		boardApi.createPost(formData)
			.then((response) => {
				navigate(
					`/board/${response.postId}`
				);
			})
			.catch((error) => {
				alert('게시글 작성에 실패했습니다. 다시 시도해주세요.');
			});
	};

  	return (
		<MainBody>
			<Section>
				<PostContainer>
					<PageTitle style = {{ border: 'none' }}>주문제작 및 문의사항 게시판</PageTitle>
					<FormContainer border="none" align="center">
						<Field type="dropDown" list={ POST_TYPE } title="구분"
							name="postType" value={formData.postType}
							onHandleChange={handleChange}
						/>
						<Field type="text" title="제목"
							name="title" value={formData.title}
							onHandleChange={handleChange}
						/>
						<TextAreaWrapper>
							<div>
								<Medium size="18px" align="left">내용</Medium>
							</div>
							<TextArea placeholder="내용을 입력해주세요."
								name="content" value={formData.content}
								onChange={handleChange}
							/>
						</TextAreaWrapper>
						<Button buttonText="제출하기" onClick={handleSubmit}></Button>
					</FormContainer>
				</PostContainer>
			</Section>
		</MainBody>
  )
}
